import {Box, Container, Typography} from "@mui/material";
import {AreaCalculatorTool} from "../../../components/pages/tools/components/AreaCalculatorTool.tsx";

export function AreaCalculatorPage() {
  return (
    <Container maxWidth="lg">
      <Box sx={{my: 4}}>
        <Typography variant="h4" component="h1" gutterBottom>
          延床面積計算ツール
        </Typography>
        <AreaCalculatorTool/>
      </Box>
    </Container>
  );
}
